import React from "react";
import { useNavigate } from "react-router-dom";

import { makeStyles } from "@mui/styles";
import StyledTableRow from "app/Components/Tables/StyledTableRow";
import PrimaryTableCell from "app/Components/Tables/PrimaryTableCell";
import { TableBody, IconButton, Tooltip, Box } from "@mui/material";

import {
  MessageOutlined,
  CheckCircle,
  DeleteOutline,
} from "@mui/icons-material";

import { formatDate, createSortedKeyMap } from "utils/helperFunctions";

const useStyles = makeStyles(() => ({
  tableCell: {
    textAlign: "center",
    margin: "auto",
    padding: "auto",
  },
}));

interface WaitlistTableBodyProps {
  gameInfo: any;
  setModalDets: (dets: any) => void;
}

const WaitlistTableBody = (props: WaitlistTableBodyProps) => {
  const { gameInfo, setModalDets } = props;
  const classes = useStyles();
  const navigate = useNavigate();

  const checkGameRunning = (playerData: any) => {
    if (gameInfo.status === "Running") {
      setModalDets({
        open: true,
        status: "addPlayer",
        playerData,
      });
    } else {
      setModalDets({
        open: true,
        status: "warning",
        playerData,
      });
    }
  };

  const removePlayer = async (playerData: any) => {
    setModalDets({
      open: true,
      status: "removePlayer",
      playerData,
    });
  };

  const renderWaitlistTableData = () => {
    if (gameInfo) {
      const { waitlist } = gameInfo;
      const SortedMap = createSortedKeyMap(gameInfo.playerlist, "timeStamp");
      const waitKeys = Object.keys(SortedMap);
      return waitKeys.map((key, index) => {
        if (!waitlist[key]) return;
        const playerData = SortedMap[key];
        return (
          <StyledTableRow key={playerData.id}>
            <PrimaryTableCell
              className={classes.tableCell}
              style={{ cursor: "pointer" }}
              onClick={() => navigate(`/profile/${playerData.id}`)}
            >
              {playerData.displayName}
            </PrimaryTableCell>
            <PrimaryTableCell className={classes.tableCell}>
              {formatDate(playerData.timeStamp)}
            </PrimaryTableCell>
            <PrimaryTableCell className={classes.tableCell}>
              <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
                {playerData.id.substring(0, 4) !== "Host" && (
                  <Tooltip title="Message Player">
                    <span>
                      <IconButton
                        onClick={() => navigate(`/messages/${playerData.id}`)}
                        size="small"
                        sx={{
                          bgcolor: "info.light",
                          color: "white",
                          width: 32,
                          height: 32,
                          "&:hover": {
                            bgcolor: "info.main",
                          },
                        }}
                      >
                        <MessageOutlined fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>
                )}

                <Tooltip title="Move To Game">
                  <span>
                    <IconButton
                      onClick={() => checkGameRunning(playerData)}
                      size="small"
                      sx={{
                        bgcolor: "success.light",
                        color: "white",
                        width: 32,
                        height: 32,
                        "&:hover": {
                          bgcolor: "success.main",
                        },
                      }}
                    >
                      <CheckCircle fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>

                <Tooltip title="Remove Player">
                  <span>
                    <IconButton
                      onClick={() => removePlayer(playerData)}
                      size="small"
                      sx={{
                        bgcolor: "error.light",
                        color: "white",
                        width: 32,
                        height: 32,
                        "&:hover": {
                          bgcolor: "error.main",
                        },
                      }}
                    >
                      <DeleteOutline fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>
              </Box>
            </PrimaryTableCell>
          </StyledTableRow>
        );
      });
    }
  };

  return <TableBody>{renderWaitlistTableData()}</TableBody>;
};

export default WaitlistTableBody;
